import React, { useState } from 'react';
import './Login.css';
import { useDispatch } from 'react-redux';
import { setTokens } from '../../store/tokensSlice';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as MapenLogo } from '../icons/logo.svg';
import ApiService from '../api_services/apiService.jsx';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('Wprowadź adres e-mail');
                    return;
                }

                if (!password.trim()) {
      setError('Wprowadź hasło');
                    return;
                }

    setIsLoading(true);

    try {
                const response = await ApiService.post('/api/auth/login', {
        email: email,
                    password: password,
                });

      if (response.data) {
        if (response.data.userRole === '[SYSTEM_ADMIN]') {
                    dispatch(setTokens({
                        accessToken: response.data.accessToken,
                        refreshToken: response.data.refreshToken,
                        userEmail: response.data.userEmail,
            userPhoneNumber: response.data.phoneNumber,
                        accessTokenExpiration: response.data.accessTokenExpiresAt,
                        refreshTokenExpiration: response.data.refreshTokenExpiresAt,
                        userRole: response.data.userRole,
                    }));
                    navigate('/');
        } else {
          setError('Brak uprawnień. Dostęp tylko dla administratorów systemu.');
        }
      } else {
        setError('Nieprawidłowa odpowiedź z serwera.');
      }
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.status === 401) {
        setError('Nieprawidłowy email lub hasło.');
      } else if (error.response?.data?.message === 'User is not activated.') {
        setError('Konto nie zostało aktywowane. Sprawdź swoją skrzynkę e-mail.');
        } else {
        setError('Błąd logowania. Spróbuj ponownie.');
      }
    } finally {
      setIsLoading(false);
        }
    };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-page" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/login_background.png)` }}>
      <div className="login-card">
        {/* Logo Section */}
        <div className="login-logo-section">
          <MapenLogo className="login-logo" />
          <h1 className="login-title">Panel Administratora</h1>
        </div>

        {/* Form Section */}
        <div className="login-form-section">
          <p className="login-subtitle">Uzupełnij dane aby kontynuować</p>

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

            <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-fields">
              {/* Email Field */}
              <div className="form-group">
                <label htmlFor="email">Adres e-mail</label>
                <div className="input-wrapper">
                <input
                  type="email"
                    id="email"
                    placeholder="adres@administrator.pl"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                    disabled={isLoading}
                />
                  <svg className="input-icon" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 14C17.2217 14 19.8333 11.3884 19.8333 8.16669C19.8333 4.94502 17.2217 2.33335 14 2.33335C10.7783 2.33335 8.16666 4.94502 8.16666 8.16669C8.16666 11.3884 10.7783 14 14 14Z" stroke="#1EE0E1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M3.98749 25.6667C3.98749 21.1283 8.47249 17.5 14 17.5C14.945 17.5 15.8667 17.605 16.7417 17.8033" stroke="#1EE0E1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>

              {/* Password Field */}
                <div className="form-group">
                <label htmlFor="password">Hasło</label>
                <div className="input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="••••••••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    disabled={isLoading}
                  />
                  <button 
                    type="button" 
                    className="password-toggle"
                    onClick={togglePasswordVisibility}
                    tabIndex="-1"
                  >
                    {showPassword ? (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.9833 10C12.9833 11.65 11.65 12.9833 10 12.9833C8.35 12.9833 7.01666 11.65 7.01666 10C7.01666 8.35 8.35 7.01666 10 7.01666C11.65 7.01666 12.9833 8.35 12.9833 10Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M10 16.8917C12.9417 16.8917 15.6833 15.1583 17.5917 12.1583C18.3417 10.9833 18.3417 9.00833 17.5917 7.83333C15.6833 4.83333 12.9417 3.1 10 3.1C7.05833 3.1 4.31666 4.83333 2.40833 7.83333C1.65833 9.00833 1.65833 10.9833 2.40833 12.1583C4.31666 15.1583 7.05833 16.8917 10 16.8917Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.1083 7.89166L7.89166 12.1083C7.35 11.5667 7.01666 10.8167 7.01666 10C7.01666 8.35 8.35 7.01666 10 7.01666C10.8167 7.01666 11.5667 7.35 12.1083 7.89166Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M14.85 4.80833C13.3917 3.70833 11.725 3.10833 10 3.10833C7.05833 3.10833 4.31667 4.84166 2.40833 7.84166C1.65833 9.01666 1.65833 10.9917 2.40833 12.1667C3.06667 13.2 3.83333 14.0917 4.66667 14.8083" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M7.01666 16.275C7.96666 16.675 8.975 16.8917 10 16.8917C12.9417 16.8917 15.6833 15.1583 17.5917 12.1583C18.3417 10.9833 18.3417 9.00833 17.5917 7.83333C17.3167 7.39166 17.0167 6.975 16.7083 6.58333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12.925 10.5833C12.7083 11.7583 11.75 12.7167 10.575 12.9333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M7.89166 12.1083L1.66666 18.3333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M18.3333 1.66667L12.1083 7.89167" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    )}
                  </button>
                </div>
                <button type="button" className="forgot-password">
                  Nie pamiętasz hasła? Resetuj hasło
                </button>
              </div>
            </div>

            {/* Submit Button */}
            <div className="login-button-wrapper">
              <button 
                type="submit" 
                className="login-button"
                disabled={isLoading}
              >
                <span>{isLoading ? 'Logowanie...' : 'Zaloguj się'}</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.43 5.93L20.5 12L14.43 18.07" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3.5 12H20.33" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
